import styled from "@emotion/styled";
import { DESKTOP } from "@/themes/device";
import {
  grayScale,
  mArticle2,
  mHeader1,
  wArticle2,
  wHeader2,
} from "@teamsparta/design-system";

export const Wrapper = styled.section`
  display: flex;
  flex-direction: column;
  margin: 0 auto;
  width: 328px;
  gap: 33px;
  ${DESKTOP} {
    justify-content: center;
    align-items: center;
    width: initial;
    gap: 71px;
    @media (max-width: 1152px) {
      width: 950px;
    }
  }
`;
export const Content = styled.main`
  display: flex;
  flex-direction: column;
  margin: 0 auto;
  width: 328px;
  ${DESKTOP} {
    flex-direction: row;
    justify-content: center;
    align-items: center;
    width: initial;
    gap: 45px;
    @media (max-width: 1152px) {
      width: 950px;
    }
  }
`;

export const Text = styled.div`
  ${DESKTOP} {
    width: 405px;
    @media (max-width: 1152px) {
      width: 350px;
    }
  }
`;

export const Title = styled.h1`
  ${mHeader1};
  color: white !important;
  ${DESKTOP} {
    ${wHeader2};
  }
`;

export const Desc = styled.p`
  ${mArticle2};
  font-weight: 400;
  color: ${grayScale.gray40} !important;
  margin-top: 40px;

  ${DESKTOP} {
    ${wArticle2};
    margin-top: 0;
  }
`;

export const DesktopVideo = styled.video`
  display: none;
  ${DESKTOP} {
    display: initial;
    width: 525px;
    height: fit-content;
    border-radius: 12px;
  }
`;
export const MobileVideo = styled.video`
  border-radius: 12px;
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
`;

export const MobileVideoWrapper = styled.div`
  position: relative;
  height: 0;
  padding-bottom: 56.25%; /* 16:9 비율 */
  border-radius: 12px;
  margin-top: 10px;
  overflow: hidden;
  ${DESKTOP} {
    display: none;
  }
`;

